import { render, staticRenderFns } from "./Interjornada.vue?vue&type=template&id=3c64f97b&"
import script from "./Interjornada.vue?vue&type=script&lang=js&"
export * from "./Interjornada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports